import { render } from "./NewInventoryTransfer.vue?vue&type=template&id=756cfccb"
import script from "./NewInventoryTransfer.vue?vue&type=script&lang=js"
export * from "./NewInventoryTransfer.vue?vue&type=script&lang=js"

import "./NewInventoryTransfer.vue?vue&type=style&index=0&id=756cfccb&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__